import React from 'react'
import { Button, Dropdown, Icon, Menu } from 'antd'
import {
  formatOptionLabel,
  SORT_DEFAULT,
  SORT_GENDER_FIRST_PREFIX,
  SORT_LANGUAGE_FIRST_PREFIX,
  SORT_OPTIONS,
  getSortOptionLabel,
  getSortValues
} from '../utils'

const { SubMenu } = Menu

const VoiceFilterControls = ({
  voices,
  sortBy,
  onSortChange,
  onResetAll,
  totalCount
}) => {
  const languageValues = getSortValues(voices, 'language')
  const genderValues = getSortValues(voices, 'gender')
  const hasAnySort = sortBy !== SORT_DEFAULT

  const sortMenu = (
    <Menu selectedKeys={[sortBy]} onClick={({ key }) => onSortChange(key)}>
      {SORT_OPTIONS.map(option => (
        <Menu.Item key={option.key}>{option.label}</Menu.Item>
      ))}

      {languageValues.length > 0 && (
        <SubMenu key="language-first" title="Language first">
          {languageValues.map(option => (
            <Menu.Item
              key={`${SORT_LANGUAGE_FIRST_PREFIX}${option.value}`}
            >{`${formatOptionLabel(option.label)} first`}</Menu.Item>
          ))}
        </SubMenu>
      )}

      {genderValues.length > 0 && (
        <SubMenu key="gender-first" title="Gender first">
          {genderValues.map(option => (
            <Menu.Item
              key={`${SORT_GENDER_FIRST_PREFIX}${option.value}`}
            >{`${formatOptionLabel(option.label)} first`}</Menu.Item>
          ))}
        </SubMenu>
      )}
    </Menu>
  )

  return (
    <div className="voice-selection-modal__filters">
      <div className="voice-selection-modal__filters-main">
        <div className="voice-selection-modal__sort-control">
          <span className="voice-selection-modal__sort-label">Sort</span>
          <Dropdown overlay={sortMenu} trigger={['click']}>
            <Button className="voice-selection-modal__sort-btn">
              <span>{getSortOptionLabel(sortBy)}</span>
              <Icon type="down" />
            </Button>
          </Dropdown>
        </div>
      </div>

      <div className="voice-selection-modal__filters-side">
        <span className="voice-selection-modal__filter-count">
          {totalCount} voice{totalCount === 1 ? '' : 's'}
        </span>
        <Button
          type="link"
          onClick={onResetAll}
          disabled={!hasAnySort}
          className="voice-selection-modal__filter-reset-btn"
        >
          Reset
        </Button>
      </div>
    </div>
  )
}

export default VoiceFilterControls
